export const VS_CODE_EXTENSION_LINK = "vscode:extension/Takeoff.takeoff-test-generation-osaka"
export const CURSOR_EXTENSION_LINK = "cursor:extension/Takeoff.takeoff-test-generation-osaka"
